export default __webpack_public_path__ + "static/media/norman-screenshot.4fe0ba9b.png";